export default __webpack_public_path__ + "img/70b1ec136c1fa6c42e54dd811647901c.svg";